import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ExchagnePanelService {
    exchangeSave$: Subject<any> = new Subject<any>();
}
